import { useQuery } from "@tanstack/react-query";
import { Search } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { globalSearch } from "../../../services/catalog.api";
import useIsMobile from "../../../customHooks/useIsMobile";
import "./SearchBar.css";
import SearchDropdown from "./SearchDropdown/SearchDropdown";

const SearchBar = () => {
  const [query, setQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  // Each keystroke would otherwise fan out to three browse endpoints.
  const [debouncedQuery, setDebouncedQuery] = useState("");

  const inputRef = useRef(null);
  const dropdownRef = useRef(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickInsideInput = inputRef.current?.contains(event.target);
      const isClickInsideDropdown = dropdownRef.current?.contains(event.target);
      if (!isClickInsideInput && !isClickInsideDropdown) setShowDropdown(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedQuery(query), 350);
    return () => clearTimeout(timer);
  }, [query]);

  const { data, isPending } = useQuery({
    queryKey: ["search", debouncedQuery],
    queryFn: () => globalSearch(debouncedQuery),
    enabled: debouncedQuery.trim().length > 0,
  });

  return (
    <>
      {isMobile ? (
        <div className="position-relative w-100" ref={inputRef}>
          <Search
            size={18}
            className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
          />
          <Form.Control
            type="text"
            placeholder="Search for food, kitchen, or location..."
            className="ps-5 py-2 rounded-pill border border-primary"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onFocus={() => setShowDropdown(true)}
          />
          {showDropdown && (
            <div ref={dropdownRef}>
              <SearchDropdown
                setShowDropdown={setShowDropdown}
                loading={isPending}
                fullResult={data}
              />
            </div>
          )}
        </div>
      ) : (
        // 💻 Desktop Design
        <div className="ownfood-search-container" ref={inputRef}>
          <div className="ownfood-search-input-wrapper">
            <input
              type="text"
              placeholder="Search your favorite food..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="ownfood-search-input"
              onFocus={() => setShowDropdown(true)}
            />
            <Search
              size={15}
              className="ownfood-search-icon"
              strokeWidth={2.1}
            />
          </div>
          {showDropdown && (
            <div ref={dropdownRef}>
              <SearchDropdown
                setShowDropdown={setShowDropdown}
                loading={isPending}
                fullResult={data}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SearchBar;
